import { removeLazyLoadingAndExecute } from '../../tools/helpers';


class LinkWithAnchorHandler {
  constructor(options = {}) {
    this.element = options.element;
  }

  init() {
    this.element.addEventListener('click', (event) => {
      event.preventDefault();
      removeLazyLoadingAndExecute(this.scrollToAnchor.bind(this));
    });
  }

  scrollToAnchor() {
    const hrefValue = CSS.escape(this.element.getAttribute('href'));
    const hashIndex = hrefValue.indexOf('#');
    let targetId = '';

    if (hashIndex !== -1) {
      // extract all after the `#`
      targetId = hrefValue.substring(hashIndex + 1);
    }

    const targetElement = document.querySelector(`#${targetId}`);
    const offsetPositionAdjustment = 40;

    if (targetElement) {
      // eslint-disable-next-line max-len
      this.targetPosition = targetElement.getBoundingClientRect().top + document.documentElement.scrollTop - offsetPositionAdjustment;

      window.scrollTo({
        top: this.targetPosition,
        behavior: 'smooth',
      });
    }
  }
}
export default LinkWithAnchorHandler;
